module.exports = __webpack_public_path__ + "media/images/logo-fortaleza-large-536e0bd97ef963a647c30049b8cf3e44.png";